import { tvpil } from '../../data/compat/tvpil';

export const experienceConfig = {
  get clientTag() {
    return tvpil.appStore.params.dmsSetting.clientTag;
  },
  get language() {
    return tvpil.appStore.localizationStore.appLanguage;
  },
  get graphQlUrl() {
    return tvpil.appStore.dms.graphQlUrl;
  },
};
